export default __webpack_public_path__ + "static/media/logo-arard.29f215df.png";